import React from 'react';
import { Link } from 'react-router-dom';
import { globalNetworks, GLOBAL_NETWORKS_AS_OF } from '../data/globalNetworks';
import { aspopUrl } from '../utils/apnic';
import { formatCompact, formatInt } from '../utils/format';
import { PageHeader } from '../components/PageHeader';
import { DataBadge } from '../components/DataBadge';
import { SourceRef } from '../components/SourceRef';
export function Networks() {
  const countries = new Set(globalNetworks.map(n => n.cca3)).size;
  const max = Math.max(...globalNetworks.map(n => n.users));
  return <>
      <PageHeader title="Who Carries the Internet" lede="The largest autonomous systems on Earth, ranked by APNIC’s estimate of the people behind them. A handful of mobile carriers in Asia carry more users than entire continents." data-id="element-761" data-mp="1rhyjkrcz1a25">
        <DataBadge mode="snapshot" source="APNIC aspop" asOf={GLOBAL_NETWORKS_AS_OF} data-id="element-762" data-mp="13tyrno3xbdlz" />
      </PageHeader>

      <section className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-763" data-mp="18s8lnvdww860">
        <dl className="grid grid-cols-3 border-b border-line" data-id="element-764" data-mp="383ouqber01uc">
          <div className="py-5 pr-4" data-id="element-765" data-mp="384zttxx90lf4">
            <dt className="text-[12.5px] text-muted" data-id="element-766" data-mp="341bollw3a1x1">ASNs tracked</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-767" data-mp="2zav81swz206g">
              {globalNetworks.length}
              <SourceRef id="apnicAspop" data-id="element-768" data-mp="2uc0f3y5aiv8m" />
            </dd>
            <dd className="font-mono text-[11px] text-faint" data-id="element-769" data-mp="2ubid0kvy5mss">global top, by users</dd>
          </div>
          <div className="border-l border-line py-5 pl-4 md:pl-6" data-id="element-770" data-mp="2pdyzxoazjg2f">
            <dt className="text-[12.5px] text-muted" data-id="element-771" data-mp="2kcjalk1ryne8">Countries covered</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-772" data-mp="2gbhal101a7b7">
              {countries}
              <SourceRef id="apnicAspop" data-id="element-773" data-mp="2bdft2ki9ag1u" />
            </dd>
          </div>
          <div className="border-l border-line py-5 pl-4 md:pl-6" data-id="element-774" data-mp="2bf92u8o61ge2">
            <dt className="text-[12.5px] text-muted" data-id="element-775" data-mp="ek49kn16sjkf">Snapshot date</dt>
            <dd className="mt-1 font-mono text-2xl tabular text-ink" data-id="element-776" data-mp="9l9sbpivb32f">
              {GLOBAL_NETWORKS_AS_OF}
              <SourceRef id="apnicAspop" data-id="element-777" data-mp="sp3fb4x00wns" />
            </dd>
          </div>
        </dl>

        <div className="mt-8 overflow-x-auto rounded-lg border border-line" data-id="element-778" data-mp="xh4o2guyk592">
          <table className="w-full min-w-[820px] border-collapse text-[13.5px]" data-id="element-779" data-mp="jpq52a11w420">
            <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-780" data-mp="jnn6v2pqv4m7">
              <tr data-id="element-781" data-mp="oosysybkynuo">
                <th scope="col" className="border-b border-line px-3 py-2.5 text-right font-normal" data-id="element-782" data-mp="om6sf20feee1">#</th>
                <th scope="col" className="border-b border-line px-3 py-2.5 font-normal" data-id="element-783" data-mp="1gfqqq064i4f3">ASN</th>
                <th scope="col" className="border-b border-line px-3 py-2.5 font-normal" data-id="element-784" data-mp="12fy4oi5jkcdg">Operator</th>
                <th scope="col" className="border-b border-line px-3 py-2.5 font-normal" data-id="element-785" data-mp="17f2d36kn662q">Country</th>
                <th scope="col" className="w-[34%] border-b border-line px-3 py-2.5 font-normal" data-id="element-786" data-mp="3n66qxhy9r45x">Est. users</th>
              </tr>
            </thead>
            <tbody data-id="element-787" data-mp="3s62slajhujib">
              {globalNetworks.map((n, i) => <tr key={n.asn} className="border-b border-line/60 last:border-b-0 hover:bg-surface" data-id="element-788" data-mp="3kl8zkmq7oma6" data-mpi={i}>
                  <td className="px-3 py-2.5 text-right font-mono text-[12px] text-muted" data-id="element-789" data-mp="3fn7a9k26zqq9">{i + 1}</td>
                  <td className="whitespace-nowrap px-3 py-2.5 font-mono text-[12.5px] text-human" data-id="element-790" data-mp="3tmozu1nbb80o">{n.asn}</td>
                  <td className="px-3 py-2.5 text-ink" data-id="element-791" data-mp="3oof67vh8kfh6">{n.name}</td>
                  <td className="whitespace-nowrap px-3 py-2.5" data-id="element-792" data-mp="30xi2v73iaqhj">
                    <Link to={`/countries/${n.cca3}`} className="inline-flex items-center gap-2 text-muted hover:text-machine" data-id="element-793" data-mp="30vounnd8vy7f">
                      <img src={`https://flagcdn.com/${n.cca2.toLowerCase()}.svg`} alt="" loading="lazy" className="h-3.5 w-5 rounded-[2px] object-cover ring-1 ring-line" data-id="element-794" data-mp="3anb1z8mgpd4w" />
                      {n.country}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5" data-id="element-795" data-mp="2i5panew9h9av">
                    <div className="flex items-center gap-3" data-id="element-796" data-mp="2d8gnt1064h3a">
                      <div className="h-1.5 flex-1 rounded-full bg-raised" aria-hidden="true" data-id="element-797" data-mp="2d7x9du9q8au0">
                        <div className="h-full rounded-full bg-human/75" style={{
                      width: `${n.users / max * 100}%`
                    }} data-id="element-798" data-mp="2qwqtyhl0sftt" />
                      </div>
                      <span className="w-20 shrink-0 text-right font-mono text-[12.5px] tabular text-ink" title={`${formatInt(n.users)} users`} data-id="element-799" data-mp="30sk2zqzj5r6u">
                        {formatCompact(n.users)}
                        <SourceRef id="apnicAspop" href={aspopUrl(n.cca2)} estimate={{
                      low: formatCompact(n.users * 0.85),
                      high: formatCompact(n.users * 1.15)
                    }} data-id="element-800" data-mp="39lx43g7qzz40" />
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-[12px] text-muted" data-id="element-801" data-mp="3ohmvjtvpd4g4">User counts are APNIC estimates from ad-based sampling; each marker links to that country’s live APNIC table.</p>
      </section>
    </>;
}